import { getConfig } from '@/config/runtime'

export interface MaxRuntimeConfig {
  environment: string
  api: {
    baseUrl: string
    wsUrl: string
    header: string
  }
  auth: {
    cognito: {
      region: string
      userPoolId: string
      userPoolClientId: string
      domain: string
      issuer: string
    }
  }
}

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '')

export const MAX_RUNTIME_CONFIG: MaxRuntimeConfig = {
  get environment() { return getConfig().environment },
  api: {
    get baseUrl() { return trimTrailingSlash(getConfig().api.baseUrl) },
    get wsUrl() { return getConfig().api.wsUrl },
    get header() { return getConfig().api.header },
  },
  auth: {
    cognito: {
      get region() { return getConfig().auth.cognito.region },
      get userPoolId() { return getConfig().auth.cognito.userPoolId },
      get userPoolClientId() { return getConfig().auth.cognito.userPoolClientId },
      get domain() { return trimTrailingSlash(getConfig().auth.cognito.domain) },
      get issuer() { return trimTrailingSlash(getConfig().auth.cognito.issuer) },
    },
  },
}

export const getMaxCognitoInitiateAuthEndpoint = (): string =>
  `https://cognito-idp.${MAX_RUNTIME_CONFIG.auth.cognito.region}.amazonaws.com/`
